import {AbstractAsset} from './abstract-asset';
import {AssetKind} from './asset-kind.enum';

export class Asset extends AbstractAsset {
    constructor() {
        super(AssetKind.GENERAL);
    }
}
